import { DOCUMENTS_PER_PAGE } from '../constants';

export const buildPagedQuery = (filter?: Record<string, unknown>, perPage: number = DOCUMENTS_PER_PAGE): string => {
    const parts = ['_page=1', `_per_page=${perPage}`];
    if (filter) parts.push(`_filter=${encodeURIComponent(JSON.stringify(filter))}`);
    return parts.join('&');
};

export const hasMoreThanLoaded = (total: number | undefined, loaded: number): boolean =>
    typeof total === 'number' && total > loaded;
